module.exports = __webpack_public_path__ + "img/Плантарный фасциит, пяточная шпора.c7b4d0f2.jpg";